import Sidebar from "@/components/Sidebar";
import { Outlet } from "react-router-dom";

export default function AppShell() {
  return (
    <div className="min-h-screen w-full flex bg-graphite-950 text-ink-primary" data-testid="app-shell">
      <Sidebar />
      <main className="flex-1 min-w-0 overflow-y-auto">
        <div className="animate-fade-up">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
